import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState(null)
  const [submitted, setSubmitted] = useState(false)

  const isFieldMissing = (val) => submitted && !val

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitted(true)

    if (!email) return

    setError(null)
    setLoading(true)

    try {
      const res = await fetch('/api/password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user: { email } }),
      })

      if (!res.ok) {
        const data = await res.json().catch(() => ({}))
        throw new Error(data.errors?.join(', ') || 'Something went wrong')
      }

      setSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src="/logo.png" alt="MyWrenchLog" className="h-16 w-auto mb-3" />
          <h1 className="text-3xl font-bold text-ink">MyWrenchLog</h1>
        </div>

        <div className="bg-surface border-[1.5px] border-ink p-6">
          <h2 className="text-xl font-extrabold text-ink mb-4">Reset Password</h2>

          {sent ? (
            <div>
              <p className="text-sm text-ink bg-surface p-3 rounded mb-4">
                If an account exists for that email, a reset link has been sent. Check your inbox.
              </p>
              <Link
                to="/login"
                className="block w-full py-2 px-4 text-sm font-medium text-center text-white bg-accent rounded-md hover:bg-accent-dark"
              >
                Back to Sign in
              </Link>
            </div>
          ) : (
            <div>
              <p className="text-sm text-gray-500 mb-4">
                Enter your email address and we'll send you a link to reset your password.
              </p>

              {error && (
                <div className="text-sm text-accent-dark bg-accent/10 border border-accent/40 p-3 mb-4">{error}</div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={`w-full border border-gray-400 rounded-md px-3 py-2.5 text-base sm:text-sm focus:ring-2 focus:ring-accent focus:border-accent ${isFieldMissing(email) ? 'border-accent' : ''}`}
                  />
                  {isFieldMissing(email) && <p className="text-xs text-accent-dark mt-1">Required</p>}
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2 px-4 text-sm font-bold text-white bg-accent rounded-md hover:bg-accent-dark disabled:opacity-50"
                >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <p className="mt-4 text-sm text-center text-gray-500">
                <Link to="/login" className="text-accent hover:text-accent-dark">
                  Back to Sign in
                </Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
